export default __webpack_public_path__ + "locales/pl/DeleteThirdPartyDialog.json?hash=1a10cb21ca3ff3d580c99956e832e61c";